import React from 'react';
import { translate } from 'react-i18next';
import { Button, Icon } from 'semantic-ui-react'

import Portal from 'modules/misc/Portal.js';
import {colors} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
}

const SurveyButtons = ({t, onSubmit, onSkip, valid, canSkip, inlineButtons}) => {
    if(inlineButtons) {
        return (
            <div>
                {Boolean(onSubmit) &&
                    <div style={style.buttonWrapper}>
                        <Button type="button" style={style.tealButton} disabled={(valid===false)} onClick={e => onSubmit(e)}>{t('Continue')}</Button>
                    </div>
                }
            </div>
        );
    } else {
        return (
            <Portal>
                <div style={style.footer}> 
                    <div style={style.footerFade} />
                    {Boolean(onSubmit) &&
                        <div style={style.buttonWrapper}>
                            <Button type="button" style={style.tealButton} disabled={(valid===false)} onClick={e => onSubmit(e)}>{t('Continue')}</Button>
                        </div>
                    }
                   
                    {Boolean(canSkip && onSkip) ? (
                            <a style={style.footerLink} onClick={onSkip}>{t('Skip')}</a>
                        ) : (
                            <div style={{...style.footerLink, cursor: 'default'}} /> 
                        )
                    }
                </div>
            </Portal>
        );
    }
};

export default translate('surveys')(SurveyButtons);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyButtons.js